import React, { useState } from "react"; // , { useState }
import { Form, Formik } from "formik";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AntSelect, CommonButton } from "../../../index";

function ManageBiographiesFilter({
  filterData,
  t,
  onReset,
  loading,
  onSubmit,
}) {
  const [disableReset, setDisableReset] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);

  let initialValues = {
    phoneNumber: filterData?.phoneNumber || "",
    status: filterData?.status || undefined,
  };
  const arrayOfData = [
    { id: "all", name: "All" },
    {
      id: "active",
      name: "Active",
    },
    {
      id: "inactive",
      name: "Inactive",
    },
  ];

  const onHandleReset = (resetForm) => {
    resetForm({});
    setDisableReset(true);
    if (filterData.phoneNumber || filterData.status) {
      onReset();
    }
  };
  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={(e) => {
        if (disableSubmit) {
          onSubmit(e);
        }
      }}
      validate={(e) => {
        if (e.phoneNumber || e.status) {
          setDisableReset(false);
          setDisableSubmit(true);
        } else {
          setDisableReset(true);
          setDisableSubmit(false);
        }
      }}
    >
      {(props) => {
        return (
          <Form>
            <div className="dropdown-body dropdown-body-rg">
              <div className="row g-3">
                {/* <div className="col-md-6">
                  <label className="overline-title overline-title-alt">
                    Creator Name
                  </label>
                  <TextInput
                    className="form-control"
                    name="creatorName"
                    type="text"
                    placeholder="Enter creator name"
                    setFieldValue={props.handleChange}
                  />
                </div> */}
                {/* <div className="col-md-6">
                  <label className="overline-title overline-title-alt">
                    Phone No
                  </label>
                  <TextInput
                    className="form-control "
                    type="text"
                    name="phoneNumber"
                    placeholder="Enter phone no"
                    setFieldValue={props.handleChange}
                  />
                </div> */}
                <div className="col-md-6">
                  <div className="form-group ">
                    <label className="overline-title overline-title-alt">
                      Status
                    </label>
                    <AntSelect
                      size="medium"
                      id="status"
                      extraClassName="form-control"
                      name="status"
                      disabled={false}
                      variant="standard"
                      placeholder="Select status"
                      setFieldValue={props.handleChange}
                      arrayOfData={arrayOfData}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="dropdown-foot between">
              <Link
                to="#"
                type="button"
                className="clickable"
                onClick={(e) => {
                  e.preventDefault();
                  if (!disableReset) {
                    onHandleReset(props.resetForm);
                  }
                }}
              >
                {t("text.common.reset")}
              </Link>

              <CommonButton
                extraClassName="btn btn-sm btn-primary"
                htmlType="submit"
                loading={loading}
                type="submit"
              >
                {t("text.common.filter")}
              </CommonButton>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default withTranslation()(ManageBiographiesFilter);
